import {
  _checkDeleted,
  _checkListDeleted,
  nameDescriptor,
} from 'pages/AutomationEngine/helpers';

const forApi = (step) => {
  const { activities } = step.details;

  return {
    details: {
      activities: activities.map(({ value }) => ({
        id: value,
      })),
    },
  };
};
const forFlow = (apiObject, addErrorMessage, messageDictionary) => {
  const { activities } = apiObject;

  let errors = {};

  errors = _checkListDeleted({
    messageDictionary,
    addErrorMessage,
    parentObject: activities,
    descriptorCallback: nameDescriptor,
    itemName: messageDictionary.activities,
    objectPath: 'activities',
  });

  const flow = {
    activities: activities.map(({ id, name, deleted }) => ({
      value: id,
      label: deleted ? `${messageDictionary.deleted} ${name}` : name,
      error: !!deleted,
    })),
    errors,
  };

  return flow;
};
export const deleteScheduledActivityDTO = {
  forApi,
  forFlow,
};
